import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// Cache the WhatsApp number to avoid repeated API calls
let cachedWhatsAppNumber = null;

// Sanitize phone number for WhatsApp URL (remove +, spaces, dashes)
const sanitizePhoneNumber = (number) => {
  if (!number) return '';
  return number.replace(/[\s\-\+\(\)]/g, '');
};

export const useWhatsAppNumber = (defaultNumber = '971504361234') => {
  const [whatsappNumber, setWhatsappNumber] = useState(cachedWhatsAppNumber || defaultNumber);

  useEffect(() => {
    if (cachedWhatsAppNumber) {
      setWhatsappNumber(cachedWhatsAppNumber);
      return;
    }

    axios.get(`${API}/api/site-config`)
      .then(res => {
        if (res.data?.whatsapp_number) {
          const sanitized = sanitizePhoneNumber(res.data.whatsapp_number);
          cachedWhatsAppNumber = sanitized;
          setWhatsappNumber(sanitized);
        }
      })
      .catch(() => {
        // Keep default on error
      });
  }, [defaultNumber]);

  return whatsappNumber;
};

export const getWhatsAppUrl = (number) => `https://wa.me/${number}`;

export default useWhatsAppNumber;
